import { Box, Typography } from "@mui/material";
import Loading from "../Loading/Loading";
import { useTranslation } from "react-i18next";
import { semanticColors } from "../../utils/colors";

/**
 * Loading / error / empty / content states of an async list.
 *
 * `error` is optional so existing callers keep working, but passing it matters:
 * without it a failed request renders as "no results", which reads as "you have
 * nothing" instead of "we could not load this".
 */
export default function AsyncResultsWrapper({
  data,
  loading,
  error,
  children
}: any) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={5}
      >
        <Loading />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography sx={{ color: semanticColors.status.error }}>
        {t("common.loadError")}
      </Typography>
    );
  }

  return data?.length ? (
    children
  ) : (
    <Typography>{t("common.noResults")}</Typography>
  );
}
